'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reselect = require('reselect');

var _reactRedux = require('react-redux');

var _AccountModal = require('./AccountModal');

var _AccountModal2 = _interopRequireDefault(_AccountModal);

var _currentUserSelector = require('../currentUserSelector');

var _elementCountSelector = require('../elementCount/elementCountSelector');

var _userUtil = require('../userUtil');

var _currentUserActions = require('../currentUserActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var accountSelector = (0, _reselect.createSelector)(_currentUserSelector.getCurrentUser, _elementCountSelector.contentElementCountSelector, _elementCountSelector.contentTotalCountSelector, _elementCountSelector.contentTotalLimitSelector, function (currentUser, elementCount, contentTotalCount, contentTotalLimit) {
    return {
        currentUser: currentUser,
        elementCount: elementCount,
        contentTotalCount: contentTotalCount,
        contentTotalLimit: contentTotalLimit,
        subscription: currentUser.get('subscription')
    };
});

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchFetchReferrals: function dispatchFetchReferrals() {
            return dispatch((0, _currentUserActions.fetchCurrentUserReferrals)());
        },
        dispatchFetchSubscription: function dispatchFetchSubscription() {
            return dispatch((0, _currentUserActions.fetchCurrentUserSubscription)());
        }
    };
};

var AccountModalContainer = (_dec = (0, _reactRedux.connect)(accountSelector, mapDispatchToProps), _dec(_class = function (_React$Component) {
    _inherits(AccountModalContainer, _React$Component);

    function AccountModalContainer() {
        _classCallCheck(this, AccountModalContainer);

        return _possibleConstructorReturn(this, (AccountModalContainer.__proto__ || Object.getPrototypeOf(AccountModalContainer)).apply(this, arguments));
    }

    _createClass(AccountModalContainer, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _props = this.props,
                dispatchFetchReferrals = _props.dispatchFetchReferrals,
                dispatchFetchSubscription = _props.dispatchFetchSubscription,
                currentUser = _props.currentUser;


            if (!currentUser.get('referrals')) dispatchFetchReferrals();

            if ((0, _userUtil.isSubscribed)(currentUser) && !currentUser.getIn(['subscription', 'detail']) || currentUser.get('customerId') && !currentUser.getIn(['customer', 'id'])) {
                dispatchFetchSubscription();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(_AccountModal2.default, this.props);
        }
    }]);

    return AccountModalContainer;
}(_react2.default.Component)) || _class);


AccountModalContainer.propTypes = {
    currentUser: _propTypes2.default.object,
    dispatchFetchReferrals: _propTypes2.default.func,
    dispatchFetchSubscription: _propTypes2.default.func
};

exports.default = AccountModalContainer;


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/AccountModalContainer.js
// module id = 2055
// module chunks = 0